import {AfterViewInit, Component, EventEmitter, forwardRef, Input, NgModule, OnInit, Output, ViewChild} from '@angular/core';
import {AbstractControl, ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgModel, ReactiveFormsModule} from '@angular/forms';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import {catchError, debounceTime, distinctUntilChanged, mergeMap, switchMap, tap} from 'rxjs/operators';
import {ListItemModel} from '../select-custom/list.item.model';
import {Observable} from 'rxjs/Observable';
import {of} from 'rxjs/observable/of';
import {CityModel} from '../../servizi/tesseramento/model/city.model';


@Component({
  selector: 'app-select-autocomplete-custom',
  templateUrl: './select-autocomplete-custom.component.html',
  styleUrls: ['./select-autocomplete-custom.component.scss'],
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectAutocompleteCustomComponent),
    multi: true
  }],
  entryComponents: []
})


export class SelectAutocompleteCustomComponent implements  ControlValueAccessor, OnInit, AfterViewInit {

  public model: any;
  @ViewChild('input') input: any;
  @Input('name')  _name: string;
  @Input('label')  _label: string;
  @Input('placeholder')  private _placeholder: string;
  @Input('disabled') private _disabled = false;
  @Input('readonly') private _readonly = false;
  @Input('control') private control: AbstractControl;
  @Input('value') private _value: any;
  @Input('service') private _service: any;
  @Output('onChange') onChange = new EventEmitter()
  private _selectItem: ListItemModel = null;
  private _items: ListItemModel[] = [];
  @Input('list') private _itemsStart: ListItemModel[] = [];
  @Input('searchFunc') private _searchFunc: Function;
  @Input('loading') private _loading: Function;
  @Input('mapping') private _mapping: Function;


  private propagateChange: Function;
  private onTouched: Function;
  private _isError: boolean;
  private _isRequired: boolean;
  private _isTouch = false;
  private _isChanged = false;
  private _messageError: string;
  private _showLoading = false;
  private _isSelected = false;

  searchFailed = false;
  search = (text$: Observable<ListItemModel>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.showLoading = true),
      switchMap(term =>
        this._loading(term, this).pipe(
          tap(() => this.searchFailed = false),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          }))
      ),
      tap(() => this.showLoading = false)
    );
  constructor() {
  }

  selectItem($event) {
    this._isSelected = true;
    this._selectItem = $event;
    this.control.setValue($event);
    this.onChange.emit({event: $event, obj: this });
    this.propagateChange($event.target);
  }
  inputFormatter(value: any) {
    return value.description;
/*    console.log('input');
    console.log(value);
    if (value instanceof ListItemModel) {
      return (value as ListItemModel).text
    }
    if (value instanceof CityModel) {
      return (value as CityModel).description
    }*/
  }
  resultFormatter(value: any) {
    if (value instanceof ListItemModel) {
      return (value as ListItemModel).text
    }
    if (value instanceof CityModel) {
      return (value as CityModel).description
    }
  }
  ngAfterViewInit(): void {
    if (!this.name) {
      throw new Error('Inserire un nome alla Input [name]');
    }
 this.registerOnChange(() => {
   if (!this.readonly && ! this.disabled) {
     this._isError = false;
     this._messageError = '';
     this._isTouch = true;
     const c = this.control.value ? this.control.value.item.description : '';
     if (this._value !== c) {
       this._isChanged = true;
     }
     this.input.nativeElement.value = c;
     this._isSelected = (c !== '');
     if (this.control.invalid) {
       this._isError = true;
       if (this.isRequired && !this.control.errors.err) {
         this._messageError = 'Campo Obbligatorio';
       } else {
         this._messageError = this.control.errors.err;
       }
     } else {
       this._isError = false;
     }
   }
  });
  }
  clear() {
    this._isSelected = false;
    this.input.nativeElement.value = '';
    this._selectItem = null;
    this.control.setValue(null);
    this.onChange.emit({event: null, obj: this });
  }

  hasRequiredField(abstractControl: AbstractControl): boolean {
    if (abstractControl.validator) {
      const validator = abstractControl.validator({}as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }
  }
  ngOnInit(): void {
    this._isRequired = this.hasRequiredField(this.control);
    // this.value = this._value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  writeValue(obj: any): void {

     // this.control.setValue(null);
    if (obj === '') {
      this._isSelected = false;
      this._selectItem = null;
      this.control.setValue(null);
      this.onChange.emit({event: null, obj: this });
      this.input.nativeElement.value = '';
    }
    if (obj instanceof ListItemModel) {
      this.control.setValue(obj.obj);
      this.input.nativeElement.value = obj.text;
    }
  }

  change( $event ) {
     this.propagateChange($event.target);
  }

  // <editor-fold desc="SET GETTER">
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get label(): string {
    return this._label;
  }
  set label(value: string) {
    this._label = value;
  }
  get placeholder(): string {
    return this._placeholder;
  }
  set placeholder(value: string) {
    this._placeholder = value;
  }
  get value(): string {
    return this.control.value;
  }
  set value(value: string) {
    this.control.setValue(value);
    this._value = value;
  }
  get isError(): boolean {
    return this._isError;
  }
  get isRequired(): boolean {
    return this._isRequired;
  }
  get isTouch(): boolean {
    return this._isTouch;
  }
  get isChanged(): boolean {
    return this._isChanged;
  }
  get messageError(): string {
    return this._messageError;
  }
  get readonly(): boolean {
    return this._readonly;
  }
  get disabled(): boolean {
    return this._disabled;
  }
  get items(): ListItemModel[] {
    return this._items;
  }
  set items(value: ListItemModel[]) {
    this._items = value;
  }
  get searchFunc(): Function {
    return this._searchFunc;
  }
  get loading(): Function {
    return this._loading;
  }
  get service(): any {
    return this._service;
  }
  get showLoading(): boolean {
    return this._showLoading;
  }
  set showLoading(value: boolean) {
    this._showLoading = value;
  }
  get mapping(): Function {
    return this._mapping;
  }
  get isSelected(): boolean {
    return this._isSelected;
  }
  // </editor-fold>

}




// WEBPACK FOOTER //
// ./src/app/component/select-autocomplete-custom/select-autocomplete-custom.component.ts